
import { mapGetters } from 'vuex'
import ProductDetails from '@/components/product-page/pdp-description/product-details'
import Benefits from '@/components/product-page/pdp-description/benefits'
import SizeFit from '@/components/product-page/pdp-description/size-fit'
import MaterialCare from '@/components/product-page/pdp-description/material-care'
export default {
  components: {
    ProductDetails,
    Benefits,
    SizeFit,
    MaterialCare,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'benefits',
      openMobileProductDetails: false,
      openMobileSizeFit: false,
      openMobileMaterialCare: false,
      openMobileBenefits: false,
    }
  },
  computed: {
    ...mapGetters({
      vxFeatures: 'common/getFeatureListPdp',
    }),
    features() {
      const lang = this.$i18n.locale.split('-')[0].toLowerCase()
      return this.product?.features?.reduce((acc, feature) => {
        const label = this.vxFeatures?.[feature]?.[lang]
        if (label) {
          acc.push({ key: feature, label })
        }
        return acc
      }, [])
    },
    benefits() {
      return this.product?.benefits?.reduce((acc, benefit) => {
        const text = this.wording.benefits_list.find(
          ({ key }) => key === benefit
        )
        if (text) {
          acc.push(text)
        }
        return acc
      }, [])
    },
    hasSizeFitContent() {
      return (
        this.product?.fitting_guide ||
        Object.keys(this.product?.sizes_details)?.length > 0
      )
    },
    hasMaterialCareContent() {
      return Object.keys(this.product?.materials)?.length > 0
    },
  },
  mounted() {
    if (this.benefits) this.activeTab = 'benefits'
    else if (this.hasSizeFitContent) this.activeTab = 'size-fit'
    else if (this.hasMaterialCareContent) this.activeTab = 'material-care'
  },
  methods: {
    setTabActive(tab) {
      this.activeTab = tab
    },
  },
}
